/** サイズセレクト画面の遷移元の値（パンくずの出し分け等で使用） */
export const SIZE_SELECT_FROM = {
  share: 'share',
  userDesigns: 'user-designs',
  productDetail: 'product-detail',
  cart: 'cart',
} as const;
export type SizeSelectFrom = (typeof SIZE_SELECT_FROM)[keyof typeof SIZE_SELECT_FROM];
